import { EditableText } from "@/components/EditableText";
import { showApiError, showSuccess } from "@/lib/toast";
import { getStockTemplateDetails, updateStockTemplate } from "@/sideEffects/api";
import { selectActiveFirm } from "@/store/appSelectors";
import { setCurrentTemplateName } from "@/store/templateEditor/templateEditorSlice";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

interface Props {
  templateId: string;
  categoryName: string;
}

export const UpdateStockTemplateCategoryNameInput: React.FC<Props> = ({ templateId, categoryName }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const activeFirm = useSelector(selectActiveFirm);

  const updateStockTemplateMutation = useMutation({
    mutationFn: async (newCategoryName: string) => {
      const templateResponse = await getStockTemplateDetails(String(activeFirm?.firmGuid), templateId);
      const templateData = templateResponse.data;
      return updateStockTemplate({
        id: templateId,
        firmGuid: String(activeFirm?.firmGuid),
        viewport_size: templateData.viewport_size,
        canvas_data: templateData.canvas_data,
        name: templateData.name,
        categoryName: newCategoryName,
      });
    },
    onSuccess: (_data, newCategoryName) => {
      showSuccess(t("common.updatedSuccess"));
      dispatch(setCurrentTemplateName(newCategoryName));
    },
    onError: showApiError,
  });

  return (
    <EditableText
      initialText={categoryName || ""}
      onSave={(text) => updateStockTemplateMutation.mutate(text)}
      isLoading={updateStockTemplateMutation.isPending}
      isFinishedLoading={updateStockTemplateMutation.isSuccess}
    />
  );
};
